'use strict';

const ajax = require('../modules/ajax'),
    isSmallView = require('../modules/helpers/isSmallView'),
    scrollHelper = require('../modules/helpers/scroll'),
    giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    appendParamsToUrl = require('../modules/util/appendParamsToUrl'),
    setDeleteConfirmation = require('../modules/util/setDeleteConfirmation'),
    getScreenBreakpointSize = require('../modules/util/getScreenBreakpointSize'),
    getQueryParameter = require('../modules/util/getQueryParameter'),
    flyout = require('../flyout'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    validator = require('../validator'),
    registration = require('./registration'),
    prefillAddress = require('../prefill-address'),
    google = require('../modules/google'),
    productTile = require('../product-tile'),
    ritualsStyles = require('../rituals-styles'),
    ritualsFormHelper = require('../rituals-form-helper'),
    customSelect = require('../select-custom'),
    customerbarcode = require('./customerbarcode'),
    damHelper = require('../dam/dam-helper'),
    orderHistory = require('./order-history');

/**
* @function
* @description Initializes the events on the address form (apply, cancel, delete)
* @param {Element} form The form which will be initialized
*/
function initializeAddressForm() {
    const $form = $('#edit-address-form');

    $form.find('input[name="format"]').remove();
    tooltip.init();
    validator.init();

    // custom validation rule for state based on zip code for US
    const country = $('[id$=_country]').val();
    if (country === 'US') {
        // set state based on given postal code
        $('[id$=_postal]').on('blur keydown', google.places.setStateFromPostalCode);
        customSelect.init();
        google.places.setStateIDDataForPostalCode();
    }

    $form.on('click', '.js-apply-button', function (e) {
        e.preventDefault();
        $(this).prop('disabled', true);

        if (!$form.valid()) {
            return false;
        }

        const url = appendParamToURL($form.attr('action'), 'format', 'ajax');
        const applyName = $form.find('.js-apply-button').attr('name');
        const options = {
            url: url,
            data: $form.serialize() + '&' + applyName + '=x',
            type: 'POST'
        };

        $.ajax(options).done(function (data) {
            if (typeof(data) !== 'string') {
                if (data.success) {
                    flyout.closeFlyouts();
                    $('.js-account-menu-item').removeClass('active');
                    getAccountPage(Urls.accountOverview);
                } else if (data.error) {
                    page.redirect(Urls.csrffailed);
                } else {
                    $('.js-address_error').val(data.message);
                    $('.js-address_error').show();
                    return false;
                }
            } else {
                $('#dialog-container').html(data);
                account.init();
                tooltip.init();
            }
        });
    })

        .on('click', '.cancel-button, .close-button', function (e) {
            e.preventDefault();
            flyout.closeFlyouts();
        })

        .on('click', '.delete-button', function (e) {
            e.preventDefault();
            if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
                const url = appendParamsToUrl(Urls.deleteAddress, {
                    AddressID: $form.find('#addressid').val(),
                    format: 'ajax'
                });
                $.ajax({
                    url: url,
                    method: 'POST',
                    dataType: 'json'
                }).done(function (data) {
                    if (data.status.toLowerCase() === 'ok') {
                        flyout.closeFlyouts();
                        page.refresh();
                    } else if (data.message.length > 0) {
                        $('.js-address_error').val(data.message);
                        $('.js-address_error').show();
                        return false;
                    } else {
                        flyout.closeFlyouts();
                        page.refresh();
                    }
                });
            }
        });

    initAddressSpecificFields();
}

function initAddressSpecificFields() {
    const country = $('[id$=_country]').val();
    if (country.toLowerCase() !== 'hk') {
        return;
    }

    const preselectedValues = {
        city: $('input[name="preselected-city"]').val(),
        district: $('input[name="preselected-district"]').val(),
        subdistrict: $('input[name="preselected-subdistrict"]').val()
    };

    const $townCityDropDownProfile = $('#dwfrm_profile_address_city');
    const $districtDropDownProfile = $('#dwfrm_profile_address_district');
    const $subdistrictDropDownProfile = $('#dwfrm_profile_address_subdistrict');

    if ($townCityDropDownProfile && $districtDropDownProfile && $subdistrictDropDownProfile) {
        ritualsFormHelper.initTownDistrictFields($townCityDropDownProfile, $districtDropDownProfile, $subdistrictDropDownProfile, preselectedValues);
    }
}

/**
* @private
* @function
* @description Toggles the list of Orders
*/
function toggleFullOrder () {
    function toggleOrder(element) {
        const $orderBlock = $(element);
        const $detailsEl = $orderBlock.find('.js-order-details-dropdown');

        if ($detailsEl.is(':hidden')) {
            $orderBlock.addClass('active');
            $detailsEl.slideDown('slow');
            damHelper.updateImages($detailsEl);
        } else {
            $orderBlock.removeClass('active');
            $detailsEl.slideUp('slow');
        }
    }

    $('body').on('click','.js-order-block', function(){
        toggleOrder(this);
    });

    $('body').on('keydown','.js-order-block', function(event) {
        if (event.which == 13 || event.which == 32) {
            toggleOrder(this);
        }
    });

    $('body').on('click', '.js-order-details-dropdown',function(e){
        e.stopPropagation();
    });
}
/**
* @private
* @function
* @description Binds the events on the address form (edit, create, delete)
*/
function initAddressEvents() {
    $(document).on('click', '.js-address-edit', function (e) {
        e.preventDefault();
        const $addressActions = $(this).parent();

        const countryCode = $addressActions.data('country-code');
        const addressCountryCode = $addressActions.data('address-country-code');

        if (countryCode && countryCode != addressCountryCode) {
            $('html, body').scrollTop(0);

            $.ajax({
                url: Urls.addressEditGetCountrySelector,
                data: {addressCountryCode},
                type: 'POST',
                success: function(response) {
                    $('.js-country-selector-wrapper').html(response);
                    showAccountLocaleSelectDialog();
                }
            });
        } else {
            $(this).addClass('js-triggered-flyout');
            initAddressFlyout(this.href);
        }
    }).on('click', '.js-address-create', function(e) {
        e.preventDefault();
        $(this).addClass('js-triggered-flyout');
        initAddressFlyout(this.href);
    }).on('click', '.js-address-delete', function (e) {
        e.preventDefault();

        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    $('.js-address_error').val(data.message);
                    $('.js-address_error').show();
                    return false;
                } else {
                    page.refresh();
                }
            });
        }
    });
}

/**
 * @private
 * @function
 * @description Opens country siwtch dialog when user tries to edit address from other
 * locale then the current one
 */
function showAccountLocaleSelectDialog() {
    dialog.open({
        target: $('.js-country-select-dialog'),
        options: {
            modal: true,
            dialogClass:'country-selector-dialog account-country-dialog',
            minHeight: 0,
            position: {
                my: 'top',
                at: 'top+15%',
                of: window
            },

            open: function() {
                const countrySelectDialog = $('.js-country-select-dialog');
                const modalOverlay = $('.js-modal-overlay');

                modalOverlay.show();
                countrySelectDialog.addClass('open');

                scrollHelper.disableScroll();

                const title = $('.js-dialog-title').html();
                $('span.ui-dialog-title').append('<h3 class="title">' + title + '</h3>');
                $('span.ui-dialog-title').html(function(i,h){
                    return h.replace(/&nbsp;/g,'');
                });

                const popupLabelText = $('.js-close-popup-text').html();
                $('.ui-dialog-titlebar-close').attr('aria-label', popupLabelText);

                $(document).one('click', '.ui-dialog-titlebar-close, .ui-widget-overlay, .js-close-dialog, .js-modal-overlay', function(e) {
                    e.preventDefault();
                    countrySelectDialog.dialog('close').removeClass('open');
                    modalOverlay.hide();
                    scrollHelper.enableScroll();
                });

                $(document).one('click','.js-redirect-locale',function(e){
                    e.preventDefault();
                    const target = e.target;
                    const url = $(target).attr('href');
                    window.location.href = url;
                });

                $(document).on('keydown', function(e) {
                    if (e.which == 27 && countrySelectDialog.hasClass('open')){
                        countrySelectDialog.dialog('close').removeClass('open');
                        modalOverlay.hide();
                        scrollHelper.enableScroll();
                    }
                });
            },

            autoOpen: true
        }
    });
}

/**
 * @private
 * @function
 * @param {string} href: Url of content to load in flyout
 * @description Shows a flyin with address edit form loaded inside
 */
function initAddressFlyout(href) {
    flyout.load({
        url: href,
        open: function () {
            $('.js-generic-flyout').addClass('address-flyout js-address-flyout');

            const editAddressFlyoutClass = '.js-address-flyout';
            const editAddressFlyoutCloseClass = '.js-address-flyout-inner .js-close-flyout';
            const hasCloseButton = $(editAddressFlyoutCloseClass).length > 0;
            const $flyoutDropdown = $('.js-generic-flyout').find('.js-custom-select');

            if (!hasCloseButton) {
                $(editAddressFlyoutClass).find('.js-close-flyout').appendTo('.js-address-flyout-inner');
            }

            initializeAddressForm();
            google.places.init();
            ritualsStyles.initInputStyles();

            if ($flyoutDropdown.length) {
                customSelect.init();
                $flyoutDropdown.each(function () {
                    if (!$(this).parents('.selectric-js-custom-select').length) {
                        if (!isSmallView()) {
                            $(this).attr('tabindex', '-1');
                        }
                    }
                });
            }

            $('.js-account-address-list').find('input:not(.selectric-input ):first').focus();
            flyoutAccessibility();
        },
        close: function () {
            $(document).find('.js-triggered-flyout').focus().removeClass('js-triggered-flyout');
        }
    });
}

/**
* @private
* @function
* @description Binds the events of the payment methods list (delete card)
*/
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        flyout.load({
            url: $(e.target).attr('href'),
            open: function () {
                open: initializePaymentForm; /* eslint-disable-line */
            }
        });
    });

    const paymentList = $('.payment-list');
    if (paymentList.length === 0) {
        return;
    }

    setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));

    $('form[name="payment-remove"]').on('submit', function (e) {
        e.preventDefault();
        // override form submission in order to prevent refresh issues
        const button = $(this).find('.delete');
        $('<input/>').attr({
            type: 'hidden',
            name: button.attr('name'),
            value: button.attr('value') || 'delete card'
        }).appendTo($(this));
        const data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: data
        })
            .done(function () {
                page.redirect(Urls.paymentsList);
            });
    });
}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        flyout.closeFlyouts();
    });
}

/**
* @private
* @function
* @description Inits account menu click event handlers
*/
function initAccountMenu(){
    $('body').on('click', '.js-account-menu-item, .js-overview-item', function(e){
        e.preventDefault();

        let navigate = true;
        const shouldConfirm = $(this).data('confirmPageChange');

        if (shouldConfirm) {
            navigate = confirm(Resources.CONFIRM_LEAVE_REGISTRATION);
        }

        if (navigate){
            $(this).removeData('confirmPageChange');
            // remove active class from other items and add it to new one
            $('.js-account-menu-item').removeClass('active');
            $(this).addClass('active');

            const href = $(this).attr('href') || $(this).data('href');
            getAccountPage(href);

            const windowSize = $(window).width();
            const breakpointSize = getScreenBreakpointSize(windowSize);

            if (breakpointSize === 'small') {
                if ($(this).data('href')) {
                    //prevent scrolling content while opening a page from account overview panel
                    $('.js-page-content').addClass('no-scrolling');

                    const dataHref = $(this).data('href');
                    const $targetNavItem = $('.js-account-menu-item[href="' + dataHref + '"]');

                    $targetNavItem.addClass('active').click();
                }
            }
        }

        setTimeout(function () {
            ritualsStyles.initInputStyles();
        }, 400);
    });

    $('body').on('click', '.js-back-to-menu', function(){
        if ((breakpointSize === 'small') && (window.location.href !== Urls.accountOverview)) {
            $('.js-account-menu-item').removeClass('active');
            scrollToContent();
        }

        if ((window.location.href === Urls.accountOverview)) {
            scrollToContent();
        }
    });

    $('body').on('click', '.js-go-to-overview', function(e){
        e.preventDefault();
        $('.js-account-menu-item').removeClass('active');
        getAccountPage(Urls.accountOverview);
    });

    $('body').on('click', '.js-account-order-pages a', function(e){
        e.preventDefault();

        const href = $(this).attr('href');
        const $targetContainer = $('.js-content-wrapper');

        ajax.load({
            url: href,
            target: $targetContainer,
            callback: function() {
                // replaces the url in the address bar without pushing an entry to history,
                // useful when refreshing pages on mobile
                window.history.replaceState({},'', href);

                const headerHeight = $('.js-header').outerHeight() + 2;
                $('html, body').animate({scrollTop: $('body').offset().top + headerHeight}, 800);
            }
        });
    });

    // mobile only: if url is not for the account overview, take the user straight to the page they want
    const windowSize = $(window).width();
    const breakpointSize = getScreenBreakpointSize(windowSize);
    if ((breakpointSize === 'small') && (window.location.href !== Urls.accountOverview)) {
        scrollToContent();
    }
}

function initNewsletterEvents() {
    $('.js-newsletter_country_select').val($('#currentCountry').val());
    buildLocalesOptions();
    updateFlags();

    if ($('#countryChanged').val() == 'true') {
        const addressCountryCode = $('#currentCountry').val();
        const languageCode = $('#currentLanguage').val();
        const newsletterPage = true;
        if (!window.location.href.includes($('#currentCountry').val().toLowerCase())) {
            $('html, body').scrollTop(0);

            $.ajax({
                url: Urls.addressEditGetCountrySelector,
                data: {addressCountryCode, newsletterPage, languageCode},
                type: 'POST',
                success: function(response) {
                    $('.js-country-selector-wrapper').html(response);
                    showAccountLocaleSelectDialog();
                }
            });
        }
    }

    $('.js-newsletter_country_select').on('change', function () {
        const countryListValue = $('.js-newsletter_country_select').val();
        const currentCountry = $('#currentCountry').val();
        buildLocalesOptions();
        updateFlags();

        if (countryListValue.toLowerCase() === currentCountry.toLowerCase()) {
            $('.policyCheckbox').hide();
            $('.btn--submit').prop('disabled', false);
            return;
        }

        $('.policyCheckbox').show();
        $('#dwfrm_profile_newsletter_acceptedPolicy').prop('checked', false);
        $('.btn--submit').prop('disabled', true);
    });

    $('#dwfrm_profile_newsletter_acceptedPolicy').on('change', function () {
        if (this.checked) {
            $('.btn--submit').prop('disabled', false);
        } else {
            $('.btn--submit').prop('disabled', true);
        }
    });
}

function initNifEvents() {
    const $inputCheckbox = $('#RegistrationForm input[id$=addNifNumber]');
    const $fieldWrapper = $('#RegistrationForm').find('input[id$=nifNumber]').parent();
    const $inputNif = $('#RegistrationForm').find('input[id$=nifNumber]');

    if (!$inputCheckbox.length) {
        return;
    }

    if ($inputNif.val()) {
        $inputCheckbox.prop('checked', true);
        $fieldWrapper.css('display', 'block');
    } else {
        $inputCheckbox.prop('checked', false);
        $fieldWrapper.css('display', 'none');
    }

    $inputCheckbox.on('change', function() {
        if (!$(this).is(':checked')) {
            $fieldWrapper.css('display', 'none');
            return;
        }

        $fieldWrapper.css('display', 'block');
    });
}

function buildLocalesOptions(){
    const locales = $('.js-newsletter_country_select').find('option:selected').data('locales');
    const languageList = $('.js-newsletter_language_select');

    if (!locales) {
        return;
    }

    $('option', languageList).remove();
    locales.forEach((locale) => {
        const option = $('<option>')
            .attr('url', locale.url)
            .attr('label', locale.label)
            .attr('is-default', locale.isDefault)
            .val(locale.value)
            .text(locale.label);
        if (locale.isSelected) {
            option.attr('selected','selected');
        }

        languageList.append(option);
    });

    if (!languageList.find('option:selected')) {
        languageList.find('option[is-default=true]').attr('selected','selected');
    }
}

function updateFlags() {
    $('.js-newsletter_country_select').css({
        backgroundImage: 'url("' + $('.js-newsletter_country_select').find('option:selected').attr('flag') + '")'
    });
}

function flyoutAccessibility() {
    const addressFlyoutCloseClass = '.js-address-flyout .js-close-flyout';
    $(document).on('keydown', addressFlyoutCloseClass, function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $('.js-account-address-list').find('input').first().focus();
        } else if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $('.js-account-address-list .js-apply-button').focus();
        }
    });

    $(document).on('keydown', '.js-address-flyout input:first', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $(addressFlyoutCloseClass).focus();
        }
    });
}

/**
* @private
* @function
* @description Loads with ajax the account page content
*/
function getAccountPage(href) {
    const $targetContainer = $('.js-content-wrapper');

    ajax.load({
        url: href,
        target: $targetContainer,
        callback:function(response){
            if (response.includes('loginajax.isml')){
                window.location.replace(Urls.getLoginPage);
            }

            const windowSize = $(window).width();
            const breakpointSize = getScreenBreakpointSize(windowSize);
            const $personalFormSelect = $('.js-account-form-personal').find('.js-custom-select');

            if (breakpointSize === 'small') {
                scrollToContent();
            } else {
                if ($personalFormSelect.length && !$personalFormSelect.parent('.selectric-hide-select').length) {
                    $personalFormSelect.selectric();
                    if (!isSmallView()) {
                        $personalFormSelect.attr('tabindex', '-1');
                    }
                }
            }

            // replaces the url in the address bar without pushing an entry to history,
            // useful when refreshing pages on mobile
            window.history.replaceState({},'', href);

            //(Re-)Initializes any forms that may be present in the newly-loaded page
            validator.init();

            ritualsFormHelper.initializeDataMask();

            if (href.includes('order-history')) {
                orderHistory.init();
            }

            if (href.includes('newsletter-subscriptions')) {
                initNewsletterEvents();
            }

            if (href.includes('edit-profile')) {
                initNifEvents();
            }

            //reinit the barcode image
            if ($('.js-member-barcode').length) {
                customerbarcode.init();
            }
        }
    });
}

/**
* @private
* @function
* @description Scrolls to the main content
*/
function scrollToContent(){
    const $footer = $('.js-footer');
    const $pageContent = $('.js-page-content');
    const $rightContent = $('.js-account-right-content');
    const rightSideActiveClass = 'right-content-active';

    if ($pageContent.hasClass(rightSideActiveClass) && !$pageContent.hasClass('no-scrolling')) { // go to menu view
        $footer.removeClass('fixed');
        $pageContent.removeClass(rightSideActiveClass);
        // go to top of the page
        window.scrollTo(0, 0);
        $pageContent.css({'left': '0'});

        // wait til css animation ends
        $pageContent.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
            if ($(e.target).is(this)){
                $rightContent.hide();
                $(this).removeClass(rightSideActiveClass);
                $(this).off('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd');
            }
        });
    } else if ($pageContent.hasClass('no-scrolling')) {
        $pageContent.removeClass('no-scrolling');
        ritualsStyles.initInputStyles();
    } else if (!$pageContent.hasClass('no-scrolling')) { // go to page content view
        $footer.addClass('fixed');
        if ($rightContent.length > 0) {
            $rightContent.show();

            // calc left position
            const contentLeftOffset = $rightContent.offset().left;
            $pageContent.css({'left': - contentLeftOffset});

            // wait til css animation ends
            $pageContent.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
                if ($(e.target).is(this)){
                    $(this).addClass(rightSideActiveClass);
                    $(this).off('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd');
                    showNewPasswordMessage();
                }
            });
        }
    }
}

function showNewPasswordMessage(){
    const welcomeBack = getQueryParameter(window.location.href, 'welcomeBack');

    if (welcomeBack) {
        $('.js-new-password-confirmation').addClass('open');
        $('.js-modal-overlay').fadeIn();
        $('.js-new-password-confirmation').find('.js-new-password-reset').focus();
        $('.js-new-password-confirmation').find('.js-new-password-close, .js-new-password-reset').attr('tabindex', '0');
    }
}

/**
* @private
* @function
* @description Binds the events of the order, address and payment pages
*/
function initializeEvents() {
    initAccountMenu();
    toggleFullOrder();
    initAddressEvents();
    initPaymentEvents();
    initNewsletterEvents();
    initNifEvents();
    login.init();
    registration.init();
    const windowSize = $(window).width();

    if (windowSize > 767) {
        showNewPasswordMessage();
    }
}

const account = {
    init: function () {
        initializeEvents();
        giftcert.init();
        prefillAddress.init();
        customerbarcode.init();
        productTile.init();
        ritualsFormHelper.init();
        orderHistory.init();
    },
    initCartLogin: function () {
        login.init();
    }
};

module.exports = account;
